module.exports = __webpack_public_path__ + "static/media/foere.a2160828.mp3";